export function getNumberInputValue(value: string): number | null | undefined {
  const regex = new RegExp('^\\d*[0-9]?(?:\\.[0-9]{1,2})?$');
  if (!regex.test(value) || value.length > 15) {
    return;
  }
  const number = parseFloat(value);
  const newValue = isNaN(number) ? null : number;
  return newValue;
}
